export default "__VITE_ASSET__CXp0J2ic__"